module.exports = __webpack_public_path__ + "img/ic_refresh.7839aab9.svg";